import React, { useEffect } from 'react';
import { useDispatch } from '@ecommerce/nest-ssr/common';
import { ArticlesActions } from '../../../../reducers/articles';
import { LinkTarget } from 'atomic/link/link-target.enum';

interface AdFieldsInterface {
    image: string;
    leadtext: string;
    title: string;
    url: string;
    adInfo: string;
}

interface AdMetaInterface {
    adclick: string;
    dsaurl: string;
}

interface AdDataInterface {
    meta: AdMetaInterface;
    fields: AdFieldsInterface;
}

interface AdSlotNativeArticleProps {
    id: string;
    name: string;
    pos?: number;
}

const AdSlotNativeArticle: React.FC<AdSlotNativeArticleProps> = ({
    id,
    name,
    pos = 1
}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        window?.dlApi?.cmd?.push((dlApi): void => {
            dlApi.defineSlot(name, id, { pos }).registerTemplate({
                tplCode: '1746213/Teaser-Standard',
                renderAd: function({ meta, fields }: AdDataInterface): void {
                    const article = {
                        img: fields.image,
                        title: fields.title,
                        lead: fields.leadtext,
                        url: `${meta.adclick || ''}${fields.url}`,
                        target: LinkTarget.SELF,
                        dsaurl: meta.dsaurl,
                        dsaText: fields.adInfo
                    };

                    dispatch({ type: ArticlesActions.AddNativeArticle, payload: { id, article } });
                }
            });

            dlApi.fetch();
        });
    }, [dispatch, name, id, pos]);

    return null;
};

export default AdSlotNativeArticle;
